module.exports = __webpack_public_path__ + "media/result.8cb23414.mp4";